import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login/Login.vue';
import Layout from "@/layouts/Layout";
import Pages from '@/router/Pages';
import Error from "@/views/error/Error";
import Register from "@/views/register/Register";
import RegisterEndUserBaseInfo from "../views/register/RegisterEndUserBaseInfo";
import ConfirmRegisterInformation from "../views/register/ConfirmRegisterInformation";
import ConfirmSendEmailToRegisterAddress from "../views/register/ConfirmSendEmailToRegisterAddress";
import ConfirmPassword from "../views/register/ConfirmPassword";
import RedirectComponent from "@/router/RedirectComponent";
import Home from "../views/home/Home";
import EndUserRouter from '@/router/end_user_router';
import BasicLogin from "../views/login/BasicLogin";
import CommerceLawRules from "../views/commerce_law_rules/CommerceLawRules";
import SelectBooking from "@/views/home/components/SelectBooking";
import BrowserSupportAlert from "@/views/alert/BrowserSupportAlert";
import CookieRequired from "../views/error/CookieRequired";
import ResetPassword from "../views/reset_password/ResetPassword";
import ChangePasswordAfterConfirm from "../views/reset_password/components/ChangePasswordAfterConfirm";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            redirect: Pages.redirect.path,
            component: Layout,
            children: [
                {
                    path: Pages.redirect.path,
                    component: RedirectComponent,
                    meta: {
                        title: "Redirecting",
                    }
                },
                {
                    ...Pages.login,
                    component: Login,
                    meta: {
                        title: "Login Page"
                    }
                },

                {
                    ...Pages.commerceLawRules,
                    component: CommerceLawRules,
                    meta: {
                        title: "Commerce law page"
                    }
                },

                {
                    ...Pages.register,
                    component: Register,
                    meta: {
                        title: "Register Page"
                    }
                },

                {
                    ...Pages.resetPassword,
                    component: ResetPassword,
                    meta: {
                        title: "Reset Password Page"
                    }
                },

                {
                    ...Pages.changePasswordAfterConfirm,
                    component: ChangePasswordAfterConfirm,
                    meta: {
                        title: "Reset password"
                    }
                },

                {
                    ...Pages.confirmSendEmailToRegisterAddress,
                    component: ConfirmSendEmailToRegisterAddress,
                    meta: {
                        title: "Confirm Receiving Email Of User Page"
                    }
                },

                {
                    ...Pages.confirmPasswordToRegister,
                    component: ConfirmPassword,
                    meta: {
                        title: "Confirm Password Page"
                    }
                },

                {
                    ...Pages.registerEndUserBaseInfo,
                    component: RegisterEndUserBaseInfo,
                    meta: {
                        title: "Register End User Base Info Page"
                    }
                },

                {
                    ...Pages.confirmRegisterInformation,
                    component: ConfirmRegisterInformation,
                    meta: {
                        title: "Confirm Register Information Page"
                    }
                },
                {
                    name: "Home",
                    path: "/home",
                    component: Home,
                    meta: {
                        title: "Home"
                    }
                },
                {
                    ...Pages.bookingCalendar,
                    component: SelectBooking,
                    meta: {
                        title: "Booking Calendar"
                    }
                },

                ...EndUserRouter,

                /*{
                    ...Pages.orderBooking,
                    component: BookingOrder,
                    meta: {
                        title: "Order booking"
                    }
                },*/

                /* Add more child routes here*/
            ]
        },
        {
            ...Pages.basicLogin,
            component: BasicLogin,
            meta: {
                title: "Basic Login"
            }
        },
        {
            ...Pages.login,
            component: Login,
            meta: {
                title: "Login Page"
            }
        },

        {
            ...Pages.register,
            component: Register,
            meta: {
                title: "Register Page"
            }
        },
        {
            name: "Cookie Required",
            path: "/cookieRequired",
            component: CookieRequired,
            meta: {
                title: "Cookie Required"
            }
        },
        {
            ...Pages.notFound,
            component: Error,
            meta: {
                title: "Not found",
                error404: true,
            }
        },
        {
            ...Pages.forbidden,
            component: Error,
            meta: {
                title: "Access denied",
                error403: true,
            }
        },

        {
            ...Pages.browserSupportAlert,
            component: BrowserSupportAlert,
            meta: {
                title: "System Alert"
            }
        }

    ]
});
router.afterEach((to, from) => {
    // fixed this title.
    document.title = "沖縄ちゅらネット予約";
    // document.title = to.meta.title;
});
export default router;
